import { Component, OnInit, ChangeDetectionStrategy, ViewEncapsulation, ChangeDetectorRef } from '@angular/core';
import { ApexOptions } from 'ng-apexcharts';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import moment from 'moment';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { ResearchService } from 'app/modules/research/research.service';
import { TimeSeriesChartService } from '../time-series-charts.service';
import { Property } from 'app/modules/projects/projects.types';
import { TimeSeriesChart } from '../time-series-charts.types';
import { AddTimeSeriesChartComponent } from '../add-time-series-chart/add-time-series-chart.component';
import { FieldDef } from 'app/core/models';
import { NewPermission } from '@core/enums';

@Component({
  selector: 'time-series-charts-analytics',
  templateUrl: './analytics.component.html',
  styleUrls: ['./analytics.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimeSeriesChartsAnalyticsComponent implements OnInit {
  public postalCode = null;
  public demographics = null;
  public esriDemographics = null;
  public employment = null;
  public permitsSurvey = null;
  public property: Property;
  public latitude = null;
  public longitude = null;

  public timeSeriesCharts: TimeSeriesChart[] = null;

  timeSeriesFields$: Observable<FieldDef[]>;

  censusPermitsOptions: ApexOptions;
  censusPermitsData: any;

  private _unsubscribeAll: Subject<void>;
  NewPermission = NewPermission;
  /**
   * Constructor
   */
  constructor(
    private _changeDetectorRef: ChangeDetectorRef,
    private _researchService: ResearchService,
    private _timeSeriesChartService: TimeSeriesChartService,
    private _matDialog: MatDialog,
  ) {
    this._unsubscribeAll = new Subject();
  }

  ngOnInit() {
    this._timeSeriesChartService.timeSeriesCharts$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((timeSeriesCharts: TimeSeriesChart[]) => {
        this.timeSeriesCharts = timeSeriesCharts;
        this._changeDetectorRef.markForCheck();
      });

    this.timeSeriesFields$ = this._timeSeriesChartService.getTimeSeriesFields();
  }

  addTimeSeriesChart() {
    const dialogRef = this._matDialog.open(AddTimeSeriesChartComponent, {
      panelClass: 'mailbox-compose-dialog',
      data: {
        related_to_type: this._timeSeriesChartService.relatedToType,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      this._changeDetectorRef.markForCheck();
    });
  }

  onSaveColumns($event, chart): void {
    //this.pipeline.table_definition = JSON.stringify({ fields: this.displayColumns });
  }
}
